import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import {
  mutationOptions,
  withError,
  withInvalidate,
} from '@/react-tools/react-query';
import { buildUrl } from '@/react/edge/edge-stacks/queries/buildUrl';
import {
  EdgeStack,
  StaggerConfig,
  HelmConfig,
} from '@/react/edge/edge-stacks/types';
import { EdgeGroup } from '@/react/edge/edge-groups/types';

import { queryKeys } from '../../queries/query-keys';

export interface UpdateEdgeStackHelmRepoPayload {
  id: EdgeStack['Id'];
  edgeGroups: Array<EdgeGroup['Id']>;
  helmConfig: HelmConfig;
  staggerConfig?: StaggerConfig;
}

export function useUpdateEdgeStackHelmRepoMutation() {
  const queryClient = useQueryClient();

  return useMutation(
    updateEdgeStackHelmRepo,
    mutationOptions(
      withError('Failed updating stack'),
      withInvalidate(queryClient, [queryKeys.base()])
    )
  );
}

async function updateEdgeStackHelmRepo({
  id,
  edgeGroups,
  helmConfig,
  staggerConfig,
}: UpdateEdgeStackHelmRepoPayload) {
  try {
    await axios.put(buildUrl(id, 'helmRepo'), {
      EdgeGroups: edgeGroups,
      HelmConfig: helmConfig,
      StaggerConfig: staggerConfig,
    });
  } catch (err) {
    throw parseAxiosError(err as Error, 'Failed updating stack');
  }
}
